import { getOktaUserId } from 'helpers/okta-session';

export const pathWithCurrentUserId = (path: string): string => {
  let currentUserId = '';
  const oktaUserId = getOktaUserId();

  if (oktaUserId) currentUserId = `/${oktaUserId}`;

  return `${currentUserId}${path}`;
};
